import React from 'react'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import RouteAddMain from '../../components/route/RouteAddMain'
import Footer from '../../components/common/Footer'
export default function RouteAddPage() {
  return (
    <>
    <TitleBar/>
    <NavMenu/>
    <RouteAddMain/>
    <Footer/>
    </>
  )
}
